// Badges projet communs : référence (code court) + « Nom à compléter ». Icônes Lucide sans fond.
import { AlertTriangle } from "lucide-react";

export function ProjectRefBadge({ reference, size = 11, color = "#4fc79c", testid }) {
  if (!reference) return null;
  return (
    <span className="inline-flex items-center font-bold tabular-nums" style={{ fontSize: size, color, letterSpacing: 0.3, padding: "1px 7px", borderRadius: 20, border: `0.5px solid ${color}66`, lineHeight: 1.5 }} data-testid={testid}>
      {reference}
    </span>
  );
}

export function NameMissingBadge({ size = 10.5, testid }) {
  return (
    <span className="inline-flex items-center" style={{ gap: 4, fontSize: size, color: "#E0A42E", padding: "1px 7px", borderRadius: 20, border: "0.5px solid #E0A42E99", lineHeight: 1.5 }} data-testid={testid}>
      <AlertTriangle size={size + 1} style={{ color: "#E0A42E" }} />Nom à compléter
    </span>
  );
}
